import { CSSProperties, FC, ReactNode } from "react";

const ButtonSmall: FC<{
  onClick: () => void;
  color?: string;
  children: ReactNode;
  style?: CSSProperties;
}> = ({ color = "#444", onClick, children, style }) => {
  return (
    <button
      onClick={onClick}
      className="button button-fill"
      style={{
        height: 30,
        backgroundColor: color,
        ...style,
      }}
    >
      {children}
    </button>
  );
};

export default ButtonSmall;
